export const BUSINESS_PRICE_TBD = "BUSINESS_PRICE_TBD";

export const ACCOUNT_TYPES = {
  personal: {
    id: "personal",
    label: "Individual",
    description: "A single-user ManuCalc workspace for personal projects, calculations, references, saved work, AI, and shop records.",
  },
  business: {
    id: "business",
    label: "Business",
    description: "A company workspace with employees, shared records, routing, approvals, plans, SOPs, and shop operations tools.",
  },
};

export const PRODUCT_TIERS = {
  lite: {
    id: "lite",
    accountType: "personal",
    name: "ManuCalc Lite",
    monthlyPrice: 9.99,
    priceLabel: "$9.99/mo",
    stripePriceEnv: "REACT_APP_STRIPE_LITE_PRICE_ID",
    metadata: {
      accountType: "personal",
      productTier: "lite",
    },
    description: "Core personal project workspace, manufacturing calculations, and searchable formula/material references for individual users.",
    highlights: [
      "Core calculators",
      "Formula and material references",
      "Saved calculations",
      "Personal projects",
      "Basic exports",
    ],
  },
  standard: {
    id: "standard",
    accountType: "personal",
    name: "ManuCalc Standard",
    monthlyPrice: 19.99,
    priceLabel: "$19.99/mo",
    stripePriceEnv: "REACT_APP_STRIPE_STANDARD_PRICE_ID",
    metadata: {
      accountType: "personal",
      productTier: "standard",
    },
    description: "Expanded calculations, G-code starter workflows, personal tool records, and advanced project references.",
    highlights: [
      "All calculators",
      "Advanced calculator modes",
      "G-code starter workflows",
      "Personal tool and machine records",
      "Advanced exports",
    ],
  },
  pro: {
    id: "pro",
    accountType: "personal",
    name: "ManuCalc Pro",
    monthlyPrice: 29.99,
    priceLabel: "$29.99/mo",
    stripePriceEnv: "REACT_APP_STRIPE_PRO_PRICE_ID",
    metadata: {
      accountType: "personal",
      productTier: "pro",
    },
    description: "Full individual ManuCalc access with the ManuCalc Assistant and advanced personal workflow tools.",
    highlights: [
      "ManuCalc Assistant",
      "Advanced G-code workflows",
      "Personal setup and inspection helpers",
      "Personal records and backups",
      "Priority calculator/request workflow",
    ],
  },
  business: {
    id: "business",
    accountType: "business",
    name: "ManuCalc Business",
    monthlyPrice: 49.99,
    priceLabel: "$49.99/mo",
    stripePriceEnv: "REACT_APP_STRIPE_BUSINESS_PRICE_ID",
    recommendedBillingModel: "base_plus_seats",
    metadata: {
      accountType: "business",
      productTier: "business",
      billingModel: "base_plus_seats",
    },
    description: "Dedicated business workspace access for company records, employees, plans, SOPs, routing, approvals, and shared shop data.",
    highlights: [
      "Company workspace",
      "Employee and role management",
      "Manufacturing Plans, SOPs, setup sheets, and travelers",
      "Shared tool, fixture, machine, and material libraries",
      "Company exports, KPIs, approvals, 3S, Shop Brain, and audit records",
    ],
  },
};

export const PERSONAL_TIER_ORDER = ["lite", "standard", "pro"];
export const BUSINESS_TIER = "business";

export const normalizeProductTier = (value) => {
  const normalized = String(value || "")
    .toLowerCase()
    .replace("manucalc_", "")
    .replace("manucalc-", "")
    .trim();

  if (["lite", "starter", "basic"].includes(normalized)) return "lite";
  if (["standard", "shop", "team"].includes(normalized)) return "standard";
  if (["pro", "professional"].includes(normalized)) return "pro";
  if (["business", "company", "enterprise", "team_business"].includes(normalized)) return "business";
  return "";
};

export const getProductTier = (tierId) =>
  PRODUCT_TIERS[normalizeProductTier(tierId)] || null;
